// extracted by mini-css-extract-plugin
export default {"resizer":"NewTable_resizer__XRDgs","resizer-hover":"NewTable_resizer-hover__pnwxl"};